import { render, staticRenderFns } from "./familyList.vue?vue&type=template&id=4b7c1e53&"
import script from "./familyList.vue?vue&type=script&lang=js&"
export * from "./familyList.vue?vue&type=script&lang=js&"
import style0 from "./familyList.vue?vue&type=style&index=0&id=4b7c1e53&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports